import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DetailPageLayout from "../../../components/detail/DetailPageLayout";
import userManualService from "../../../services/userManual";
import { instanceToken } from "../../../utils/constant";
import { dateInfoItems, formatAnswerList } from "../../../utils/detailUtils";

const DetailUserManual = ({ homeAlert }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [manual, setManual] = useState(null);

  useEffect(() => {
    const fetchManual = async () => {
      try {
        const res = await userManualService.getUserManual(instanceToken.token, id);
        setManual(res.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchManual();
  }, [id]);

  const handleRemove = async () => {
    try {
      await userManualService.deleteUserManual(instanceToken.token, id);
      homeAlert("User Manual has been removed.", false);
      navigate("/user-manual");
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };

  const answerText = manual ? formatAnswerList(manual.answers) : "";

  return (
    <DetailPageLayout
      title="User Manual Details"
      subtitle="View and manage user manual entry"
      breadcrumbs={[
        { label: "User Manual", path: "/user-manual" },
        { label: `User Manual (ID - ${id})` },
      ]}
      listPath="/user-manual"
      loading={!manual}
      editPath={manual ? `/user-manual/update/${manual.id}` : undefined}
      onRemove={handleRemove}
      contentSections={
        answerText
          ? [
              {
                title: "Answers",
                value: answerText,
                icon: "notes",
              },
            ]
          : []
      }
      infoItems={
        manual
          ? [
              { label: "ID", value: String(manual.id), icon: "id" },
              {
                label: "Title (English)",
                value: manual.question_en,
                icon: "title",
              },
              {
                label: "Title (Myanmar)",
                value: manual.question_mm,
                icon: "title",
                myanmar: true,
              },
              ...dateInfoItems(manual),
            ]
          : []
      }
      infoTitle="User Manual Information"
    />
  );
};

export default DetailUserManual;
